import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/analisisIndividual`;

// Función para obtener el acta
export const getMicroconceptos = async (navigate) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/conceptos`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener los microconceptos");
  } catch (error) {
    throw error;
  }
};

export const getVideoUrlSAS = async (videoPath, navigate) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/videosSAS?videoUrl=${encodeURIComponent(videoPath)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data.videoUrl;
    }

    throw new Error("Error al obtener la URL del video");
  } catch (error) {
    throw error;
  }
};
